import { KeyRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Mirrors the key consumed by AdminManagementPage's auto-open hook. Kept in
// sync by convention — bumping one without the other breaks the hand-off.
const AUTO_OPEN_KEY = 'autoOpenRootTransfer';

// PRD §3.6 — Card 3, Root-only. Only the entry point lives here; the actual
// 3-step Root Transfer slide panel lives in PRD 15 §3.5 and is already wired
// to auto-open on /admin-management when the sessionStorage flag is set.
export function RootTransferEntryCard() {
  const { t } = useTranslation('my-profile');
  const navigate = useNavigate();

  const handleStart = () => {
    sessionStorage.setItem(AUTO_OPEN_KEY, 'true');
    navigate('/admin-management');
  };

  return (
    <section
      className="card"
      style={{ padding: 24 }}
      aria-labelledby="mp-root-heading"
    >
      <h2
        id="mp-root-heading"
        style={{
          fontSize: 16,
          fontWeight: 600,
          margin: '0 0 8px 0',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span>{t('cards.rootTransfer.title')}</span>
        <span
          className="badge"
          style={{
            background: '#fee',
            color: '#c00',
            fontSize: 11,
            padding: '2px 6px',
          }}
        >
          {t('cards.rootTransfer.badge')}
        </span>
      </h2>
      <p
        style={{
          fontSize: 13,
          color: 'var(--muted-foreground)',
          lineHeight: 1.6,
          margin: '0 0 16px 0',
          whiteSpace: 'pre-line',
        }}
      >
        {t('cards.rootTransfer.body')}
      </p>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button
          type="button"
          className="btn btn-default btn-outline"
          style={{ height: 40, display: 'inline-flex', alignItems: 'center', gap: 6 }}
          onClick={handleStart}
        >
          <KeyRound size={16} />
          {t('cards.rootTransfer.action')}
        </button>
      </div>
    </section>
  );
}
